import { useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { DraggedItem, draggedItemAtom, isDraggingAtom } from './dragState';

export const useDragState = () => {
  const [draggedItem, setDraggedItem] = useAtom(draggedItemAtom);
  const isDragging = useAtomValue(isDraggingAtom);

  const startDragging = useCallback(
    (item: DraggedItem) => {
      setDraggedItem(item);
    },
    [setDraggedItem],
  );

  const stopDragging = useCallback(() => {
    setDraggedItem(null);
  }, [setDraggedItem]);

  return {
    isDragging,
    draggedItem,
    startDragging,
    stopDragging,
  };
};
